import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Building } from '../../model/building';

export interface BuildingState extends EntityState<Building> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Building' })
export class BuildingStore extends EntityStore<BuildingState> {

  constructor() {
    super();
  }

}
